/**
 * The page's icons, as inline SVG on a 24-unit square, drawn in `currentColor`
 * so a key or a lamp colours its icon by its own state. A Brush's icon is its
 * glyph on the Grid. Checked by eye.
 */

const svg = (body: string): string =>
  `<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`

export const BRUSH_ICONS: Readonly<Record<string, string>> = {
  kick: svg(`<circle cx="12" cy="12" r="8" fill="currentColor" stroke="none"/>`),
  snare: svg(`<circle cx="12" cy="12" r="6.5" stroke-width="2.5"/>`),
  hat: svg(`<circle cx="12" cy="12" r="3" fill="currentColor" stroke="none"/>`),
  tom: svg(`<path d="M12 3.5 20.5 12 12 20.5 3.5 12Z" fill="currentColor" stroke="none"/>`),
  wall: svg(`<rect x="4.5" y="4.5" width="15" height="15"/>`),
  eraser: svg(
    `<rect x="5" y="5" width="14" height="14" stroke-width="1.5" stroke-dasharray="2.5 2.5"/><circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/>`
  )
}

/** The splash's pictures: join and listen, tap to hear again, time's up, sound's gone. */
export const SPLASH_ICONS: Readonly<Record<string, string>> = {
  join: svg(
    `<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor" stroke="none"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>`
  ),
  // The phone paused the sound: the join picture again, since a tap brings it back.
  paused: svg(
    `<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor" stroke="none"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/>`
  ),
  hour: svg(
    `<path d="M6.5 3.5h11M6.5 20.5h11M8 3.5c0 5 8 5 8 8.5s-8 3.5-8 8.5M16 3.5c0 5-8 5-8 8.5s8 3.5 8 8.5"/>`
  ),
  stopped: svg(
    `<path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor" stroke="none"/><path d="M15.5 9.5l5 5M20.5 9.5l-5 5"/>`
  )
}
